import { IGetDashboardComprasUseCase } from "../../../presentation/useCases/read/get_dashboard_compras_use_case";
import { DashboardCompras } from "../../models/dashboard_compras";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetDashboardComprasUseCase
 */

export class GetDashboardComprasUseCase implements IGetDashboardComprasUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getDashboardCompras(
  ): Promise<DashboardCompras> {
    return await this.repository.getDashboardCompras();
  }
}
